<template>
    <header class="chat-header">
      <div>
        <img src="https://www.fishersci.com/content/dam/fishersci/en_US/images/fisher-scientific-logo-2017.svg" alt="Fisher Logo" class="fishersci-logo" id="scientific-header-image" data-analytics-section="Global Nav" data-analytics-container="Fisher Scientific" data-analytics-parent="Header" data-analytics-text="Logo" data-uw-rm-ima-original="fisher logo">
        <span v-if="darkProdFlag" class="dark-release-label">(Dark)</span>
      </div>
      <div class="header-buttons">
        <span
          v-if="chatMinimizedState === 'none' && getUnreadMessages > 0"
          class="unread-badge">
          {{ getUnreadMessages }}
        </span>
        <button
          v-if="chatMinimizedState === 'block' && (chatStarted || visibilityOfPrechatForm)"
          class="header-button"
          @click="toggleChatSize">
          <arrow-expand v-if="!chatExpand" :size="19.2" />
          <arrow-collapse v-else :size="19.2" />
        </button>
        <button v-if="chatStarted" class="header-button" @click="$emit('handleChatMinimize')">
          <minus v-if="chatMinimizedState == 'block'" :size="19.2" />
          <plus v-else-if="chatMinimizedState === 'none'" :size="19.2" />
        </button>
        <button  class="header-button" @click="handleCloseWidget">
          <close :size="19.2" />
        </button>
      </div>
    </header>
</template>

<script>
import ArrowExpand from 'vue-material-design-icons/ArrowExpand.vue'
import ArrowCollapse from 'vue-material-design-icons/ArrowCollapse.vue'
import Minus from 'vue-material-design-icons/Minus.vue'
import Plus from 'vue-material-design-icons/Plus.vue'
import Close from 'vue-material-design-icons/Close.vue'
import { useWidgetStore } from '@/store'
import { mapState } from 'pinia'

export default {
  name: 'ChatHeader',
  components: {
    ArrowExpand,
    ArrowCollapse,
    Minus,
    Plus,
    Close
  },
  props: {
    visibilityOfPrechatForm: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      chatExpand: false
    }
  },
  computed: {
    ...mapState(useWidgetStore, [
      'chatStarted',
      'chatMinimizedState',
      'getUnreadMessages',
      'darkProdFlag'
    ])
  },
  emits: ['handleChatSize', 'handleChatMinimize', 'closeWidgetEvent'],
  mounted () {
  },
  methods: {
    handleCloseWidget () {
      this.$emit('closeWidgetEvent', true)
    },
    toggleChatSize () {
      this.chatExpand = !this.chatExpand
      this.$emit('handleChatSize', this.chatExpand)
    }
  }
}
</script>

<style scoped>
.chat-container
   .chat-header {
    position: relative;
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #DCDCDC;
    box-shadow: none;
    height: auto;
  }

  .chat-tf-header{
    border-top: 3px solid #E71316
  }
  .dark-release-label {
    font-size: 12px;
  }

  .header-buttons {
    display: flex;
    color: #000;

    .header-button:hover,
    .header-button:focus {
      background: transparent;
      color: #000;
    }
  }
  .header-button{
    border: none;
    background-color: transparent;
    cursor: pointer;
    padding: 1px 6px;
    color: #000;
  }
  .header-title {
    font-size: 12px !important;
    color: #333;
    margin: 0;
  }
  .fishersci-logo {
    width: 160px;
  }
  .unread-badge{
    background-color: #ec0f0f;
    padding: 3px 10px;
    border-radius: 20px;
    font-size: 12px;
    color: #fff;
    margin-right: 5px;
  }
span.material-design-icon.close-icon::before{
  display: none !important;
}
span.material-design-icon.close-icon::after{
  display: none !important;
}
</style>
